<!-- PAGE TITLE
        ================================================== -->
<section class="page-title-section bg-img cover-background top-position1 left-overlay-dark" data-overlay-dark="9"
         data-background="img/bg/bg-04.jpg"
         style="background-image: url(assets/img/bg/bg-04.jpg);">
    <div class="container">
        <div class="row text-center">
            <div class="col-md-12">
                <h1>CHANCELLOR</h1>
            </div>
            <div class="col-md-12">
                <ul>
                    <li><a routerLink="/">Home</a></li>
                    <li><a href="#!">Chancellor</a></li>
                </ul>
            </div>
        </div>
    </div>
</section>

<!-- ABOUTUS ================================================== -->
<section class="aboutus-style-02">
    <div class="container">
        <!--<div class="row  ">
            <div class="col-lg-6 col-xl-7">
                <div class="col-lg-12 order-2 order-lg-1 ">
                    &lt;!&ndash;<section class="top-position1">
                        <div id="carouselExampleIndicators" class="carousel slide" data-bs-ride="carousel">
                                <div class="carousel-inner">
                                    <div class="carousel-item active">
                                        <div class="item bg-img cover-background pt-6 pb-10 pt-sm-6 pb-sm-14 py-md-16 py-lg-20 py-xxl-24"
                                            data-overlay-dark="0" data-background="" style="background-image: url('assets/img/chancellor/1.jpg');">
                                        </div>
                                    </div>
                                    <div class="carousel-item">
                                        <div class="item bg-img pt-6 pb-10 pt-sm-6 pb-sm-14 py-md-16 py-lg-20 py-xxl-24"
                                            data-overlay-dark="0" data-background="" style="background-image: url('assets/img/chancellor/2.jpg');">
                                        </div>
                                    </div>
                                    <div class="carousel-item">
                                        <div class="item bg-img  pt-6 pb-10 pt-sm-6 pb-sm-14 py-md-16 py-lg-20 py-xxl-24"
                                            data-overlay-dark="0" data-background="" style="background-image: url('assets/img/chancellor/3.jpg');">
                                        </div>
                                    </div>
                                </div>
                                <button class="carousel-control-prev" type="button"
                                        data-bs-target="#carouselExampleIndicators"
                                        data-bs-slide="prev">
                                    <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                                </button>
                                <button class="carousel-control-next" type="button"
                                        data-bs-target="#carouselExampleIndicators"
                                        data-bs-slide="next">
                                    <span class="carousel-control-next-icon" aria-hidden="true"></span>
                                </button>
                            </div>
                        <div class="triangle-shape top-15 right-10 z-index-9 d-none d-md-block"></div>
                        <div class="square-shape top-25 left-5 z-index-9 d-none d-xl-block"></div>
                        <div class="shape-five z-index-9 right-10 bottom-15"></div>
                    </section>&ndash;&gt;
                    <section class="top-position1">
                        <div id="carouselExampleIndicators" class="carousel slide" data-bs-ride="carousel">
                            <div class="carousel-inner">
                                <div class="carousel-item active">
                                    <div class="item bg-img"
                                         style="background-image: url('assets/img/chancellor/1.jpg');">
                                    </div>
                                </div>
                                <div class="carousel-item">
                                    <div class="item bg-img"
                                         style="background-image: url('assets/img/chancellor/2.jpg');">
                                    </div>
                                </div>
                                <div class="carousel-item">
                                    <div class="item bg-img"
                                         style="background-image: url('assets/img/chancellor/3.jpg');">
                                    </div>
                                </div>
                            </div>
                            <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="prev">
                                <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                            </button>
                            <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="next">
                                <span class="carousel-control-next-icon" aria-hidden="true"></span>
                            </button>
                        </div>
                    </section>
                </div>
            </div>
            <div class="col-lg-6 col-xl-5 mt-1-9">
                <div class="section-heading text-start mb-0">
                    <span class="sub-title">Chancellor Message</span>
                </div>
                <h2 class="h1 mb-1-6 text-primary">From the Desk of Chancellor</h2>
                <p>Higher education institutions have long been crucial to a country's social and economic advancement.
                    Arni University's position as a hub for learning, teaching, research, and excellence has grown
                    increasingly important as the amount of human knowledge grows at an accelerated rate. ARNI views
                    education holistically and equips students with the information and abilities they need to fully
                    contribute to the nation's economic growth.
                </p>
                <span class="sub-title text-secondary">Dr. Vivek Singh</span>
                &lt;!&ndash;<div class="section-heading text-start mb-0 text-center">

                </div>&ndash;&gt;
            </div>
            <div class="col-lg-12 col-xl-12 ">
                <p>It is with immense pride and privilege that I announce a transformative chapter in the journey of
                    Arni University under the guidance of our new management. Our unwavering commitment is to propel
                    Arni University to unprecedented heights, positioning it as a premier “Five-Star” educational
                    institution in the country. Everything possible, including infrastructure, upgrading of equipment,
                    latest books, and administrative / welfare facilities would be catered for to excel in the field of
                    education. As the new, yet experienced Management, we have been investing our earnest efforts to
                    take our University to become one of the best universities in the advancement of academic, human
                    capital index, research & innovation. Guided by this vision, the University has strategically
                    positioned itself to train our students to meet the development needs of the country and the
                    international human resources market.
                </p>
                <p>We also feel that it is not only the knowledge or degrees alone that produce good citizens, but also
                    the culture, ethos, values, and conducive environment which adds to the leadership skills and
                    personality as much as the knowledge. Accordingly, we have designed and nurtured the learning and
                    teaching process by hiring or partnering with, the best talents/experts available in the country.
                </p>
                <p>It is my proud privilege to formally welcome all fresh students to Arni University and I hope that
                    they all will be immensely by joining us. I would like to assure everyone that we are fully
                    dedicated to providing quality accredited career-focused education to our students. To achieve this,
                    an immersive curriculum in our University, supported by industry, has been developed to prepare our
                    students pragmatically to create a 'Centre of Excellence'. I am determined and clear in my mind that
                    we will achieve our set goals.
                </p>
                <p>We thank everyone for taking an interest in our University.</p>
            </div>
        </div>-->
        <div class="row  pt-0">
            <div class="col-lg-6 col-xl-7 h-auto">
                <div class=" border">
                    <!-- Static Image Section -->
<!--                        <div class="item bg-img cover-background pt-6 pb-10 pt-sm-6 pb-sm-14 py-md-16 py-lg-20 py-xxl-24"-->
<!--                             style="background-image: url('assets/img/chancellor/1.jpg'); background-size: cover; background-position: center; height: 100%; width: 100%;">-->
<!--                        </div>-->
                        <img src="assets/img/chancellor/1.jpg" class="" alt="" >
                </div>
            </div>
            <div class="col-lg-6 col-xl-5 align-self-center pb-md-5 pt-4 ">
                <div class="section-heading text-center text-md-start  mb-0">
                    <span class="sub-title">Chancellor Message</span>
                </div>
                <h2 class="h1 mb-1-6 text-primary text-center text-md-start ">From the Desk of Chancellor</h2>
                <p class="px-2" align="justify">Higher education institutions have long been crucial to a country's social and economic advancement.
                    Arni University's position as a hub for learning, teaching, research, and excellence has grown
                    increasingly important as the amount of human knowledge grows at an accelerated rate. ARNI views
                    education holistically and equips students with the information and abilities they need to fully
                    contribute to the nation's economic growth.
                </p>
                <div class="section-heading text-start px-1 mb-0 mt-3">
                    <span class="sub-title text-secondary">Dr. Vivek Singh</span>
                </div>

            </div>
            <div class="col-lg-12 col-xl-12 ">
                <p class="px-2" align="justify">It is with immense pride and privilege that I announce a transformative chapter in the journey of
                    Arni University under the guidance of our new management. Our unwavering commitment is to propel
                    Arni University to unprecedented heights, positioning it as a premier “Five-Star” educational
                    institution in the country. Everything possible, including infrastructure, upgrading of equipment,
                    latest books, and administrative / welfare facilities would be catered for to excel in the field of
                    education. As the new, yet experienced Management, we have been investing our earnest efforts to
                    take our University to become one of the best universities in the advancement of academic, human
                    capital index, research & innovation. Guided by this vision, the University has strategically
                    positioned itself to train our students to meet the development needs of the country and the
                    international human resources market.
                </p>
                <p class="px-2" align="justify">We also feel that it is not only the knowledge or degrees alone that produce good citizens, but also
                    the culture, ethos, values, and conducive environment which adds to the leadership skills and
                    personality as much as the knowledge. Accordingly, we have designed and nurtured the learning and
                    teaching process by hiring or partnering with, the best talents/experts available in the country.
                </p>
                <p class="px-2" align="justify">It is my proud privilege to formally welcome all fresh students to Arni University and I hope that
                    they all will be immensely by joining us. I would like to assure everyone that we are fully
                    dedicated to providing quality accredited career-focused education to our students. To achieve this,
                    an immersive curriculum in our University, supported by industry, has been developed to prepare our
                    students pragmatically to create a 'Centre of Excellence'. I am determined and clear in my mind that
                    we will achieve our set goals.
                </p>
                <p class="px-2" align="justify">We thank everyone for taking an interest in our University.</p>
            </div>
        </div>

        <div class="shape20">
            <img src="assets/img/bg/bg-02.jpg" alt="...">
        </div>
        <div class="shape18">
            <img src="assets/img/bg/bg-01.jpg" alt="...">
        </div>
        <div class="shape21">
            <img src="assets/img/bg/bg-03.jpg" alt="...">
        </div>
    </div>
</section>
